/**
 * Point d'entrée du chat Laura depuis l'en-tête de tableinox.com.
 *
 * Le widget (assets/laura-chat.js) est dérivé de celui d'Hygiène 14 : il n'écoute
 * aucun attribut, il expose une seule fonction, window.ouvrirChatTableinox(). Ce
 * fichier fait donc le lien, pour que l'en-tête n'ait rien à savoir du widget :
 *
 *   1. le bouton de l'en-tête et tout lien vers #laura ouvrent la fenêtre ;
 *   2. tant que le widget, chargé en defer, n'a pas répondu, le clic bascule sur
 *      la page contact plutôt que de ne rien faire.
 *
 * Il est volontairement séparé de sections/header-group.json et des menus : ces deux
 * endroits sont maintenus ailleurs, ce fichier n'a pas à les connaître.
 */
(function () {
  'use strict';

  var CIBLES = '.laura-head, [data-laura-chat], a[href$="#laura"], a[href*="#laura-chat"]';

  function ouvrir() {
    if (typeof window.ouvrirChatTableinox === 'function') {
      window.ouvrirChatTableinox();
      return true;
    }
    return false;
  }

  document.addEventListener('click', function (e) {
    var n = e.target;
    while (n && n.nodeType !== 1) n = n.parentNode;
    n = n && n.closest ? n.closest(CIBLES) : null;
    if (!n) return;
    e.preventDefault();
    if (ouvrir()) return;
    // Repli : le widget n'a pas fini de charger. Plutôt qu'un clic mort, la page
    // contact prend le relais.
    window.location.href = n.getAttribute('data-laura-repli') || '/pages/contact';
  });
})();
